import { FunctionComponent, useState } from "react";
import Modal from "./Modal";
import Button from "../Button";
import { buttonTypes, userTypes } from "src/utils/types";
import { useAuth } from "src/context/AuthContext";
import { INote } from "src/utils/types/NoteTypes";
import { dynamo, format } from "src/utils";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../LoadingSpinner";
import { ToastStatus, useToast } from "src/context/ToastContext";
import { AccountTypes } from "src/utils/types/UserTypes";

interface IAddNoteModalProps {
  open: boolean;
  client: userTypes.Client;
  toggleModal: () => void;
}

const AddNoteModal: FunctionComponent<IAddNoteModalProps> = ({
  open,
  client,
  toggleModal,
}) => {
  const { user, refetchUser } = useAuth();
  const { setToast } = useToast();
  const navigate = useNavigate();
  const [newNote, setNewNote] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const save = async () => {
    setLoading(true);
    if (!user) return;

    const note: INote = {
      id: -1,
      text: newNote,
      author: {
        id: user?.userId,
        name:
          user.userType === AccountTypes.REFERRAL
            ? user?.userInfo.representativeName
            : user?.userInfo.name,
      },
      date: new Date(),
    };

    try {
      await format.users.addClientNote(client, note);
      const result = await dynamo.mutations.putUser(client);

      if (result.status === 201) {
        setToast({
          message: "Client Note Added",
          status: ToastStatus.SUCCESS,
        });

        if (user.userId === client.userId) {
          refetchUser(user.userId);
        }
        navigate(0);
      }
    } catch (error: any) {
      setToast({
        message: error?.message || "Note Failed To Save",
        status: ToastStatus.FAIL,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      title="New Note"
      content={
        loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <textarea
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:border-primary mb-4"
              rows={6}
              cols={50}
              name="Notes"
              placeholder="New Note..."
              onChange={(event) => setNewNote(event.target.value)}
            ></textarea>
            <div className="flex justify-evenly">
              <Button
                text="Cancel"
                theme={buttonTypes.BUTTON_THEME_TYPES.PRIMARY_INVERSE}
                onClick={toggleModal}
                styles="mr-4"
              />
              <Button text="Save" onClick={save} />
            </div>
          </>
        )
      }
      onClose={toggleModal}
    />
  );
};

export default AddNoteModal;
